import { shellStringResources } from '../../Resources/ShellStringResources';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';
import { format, getConnectorV1Name } from '../../shared/utils/string.util';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { SalesforceServiceCloudLinkedService } from '../linkedservice/salesforce-service-cloud.linkedservice';
import { ModelConstants } from '../model-constants';
import { SalesforceDataset } from './salesforce.dataset';

@Metamodel.model({
    name: ModelConstants.salesforceServiceCloudDataset,
    disabled: isTridentInIframe(),
    display: [
        format(shellStringResources.ModelName_DatasetTemplate,
            getConnectorV1Name(shellStringResources.SalesforceServiceCloudObject_DisplayText)),
        format(shellStringResources.ModelName_DatasetsTemplate,
            getConnectorV1Name(shellStringResources.SalesforceServiceCloudObject_DisplayText))
    ],
    constraints: {
        linkedService: {
            model: SalesforceServiceCloudLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SalesforceServiceCloudDataset extends SalesforceDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
